import type React from 'react';
import styles from './index.module.scss';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/components/Dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

type ImageDialogProps = {
  imageUrl: string;
};

export const ImageDialog: React.FC<ImageDialogProps> = ({ imageUrl }) => (
  <Dialog>
    <DialogTrigger>
      <img src={imageUrl} alt="" />
    </DialogTrigger>
    <DialogContent>
      <div className={styles.imageDialogContent}>
        <VisuallyHidden>
          <DialogTitle>画像拡大</DialogTitle>
        </VisuallyHidden>
        <DialogTrigger>
          <img src={imageUrl} alt="" />
        </DialogTrigger>
      </div>
    </DialogContent>
  </Dialog>
);
